import { useHistory } from "react-router-dom";

export const tryBigIntParse = (v: any, history: ReturnType<typeof useHistory>) => {
  try {
    return BigInt(v);
  } catch {
    history.replace(`/404?bi=${encodeURIComponent(String(v))}`);
    return BigInt(-1);
  }
};
